var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.files.length)?_c('div',{staticClass:"files-container"},[_c('p',{staticClass:"files-container__files-count"},[_vm._v(_vm._s(_vm.$tc('filesCount', _vm.files.length)))]),_vm._l((_vm.files),function(file){return _c('FilePreview',{key:file.url,attrs:{"file":file}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }